/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';

export const RUNNIG_JOB_KEEP_ALIVE = 8 * 60; // 8 minutes
export const RUNNIG_JOB_KEEP_ALIVE_FREQ = 30; // 30 seconds
export const RUNNING_JOB_DELETE_NOT_KEEP_ALIVED = 30 * 60; // 30 minutes

export default declareEntity({
    entity: "runningJobs",
    graphQL: "RunningJob",
    name: "Running Tasks",
    dynamoPrefix: 'sys',
    storageType: 'silo',
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "Running Task ID (deduplication ID)",
            type: "string",
            id: true,
            defaultValue: () => {
                return uuidv4();
            },
            required: true,
            primaryKey: true,
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            defaultValue: (job) => {
                return job['channel_id'];
            },
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
            defaultValue: (job) => {
                return job['flow_id'];
            },
        },
        keepAlive: {
            name: "Last keep alive mark",
            type: "datetime",
        },
        keepAliveId: {
            name: "Keep alive ID",
            type: "uuid",
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
            defaultValue: (job) => {
                return job['flowDef_id'];
            },
        },
        flowStepDef: {
            name: "Flow Step Definition",
            type: "relation",
            to: () => types['flowStepDefs'],
            defaultValue: (job) => {
                return job['flowStepDef_id'];
            },
            relativeTo: ["flowDef"],
        },
        job: {
            name: "Job",
            type: "relation",
            to: () => types['jobs'],
            defaultValue: (job) => {
                return job['job_id'];
            },
        },
        invokeAfter: {
            name: "Invoke after",
            type: "object",
            userEditable: false,
        },
        flowInvocation: {
            name: "Flow Invocation",
            type: "relation",
            to: () => types['flowInvocations'],
            defaultValue: (job) => {
                return job['flowInvocation_id'];
            },
            relativeTo: ["flow"],
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (job) => {
                return job['organisation_id'];
            },
            required: true
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; }
});
